import {
  ONBOARDING_WIZARD_ACTIONS,
  onboardingActionsFromLabels,
} from "../../../helper/onboardingActions";

/** Chip that answers the action question with no actions. */
export const NO_ACTIONS_LABEL = "Continue without actions";

export const ACTION_STEP_SUGGESTIONS = [
  ...ONBOARDING_WIZARD_ACTIONS.map((action) => action.label),
  NO_ACTIONS_LABEL,
];

export const NO_ACTIONS_ANSWER = {
  ok: true,
  value: { selectedActions: [] },
  display: "No actions for now",
};

/**
 * Parse the action question: picked chips plus optional typed action names
 * (comma separated). Anything typed that is not a wizard action is unclear,
 * because only the seven wizard actions can run in the onboarding free run.
 */
export function parseActionStepAnswer(pendingSelection, text) {
  const typed = String(text || "")
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
  if (typed.some((label) => onboardingActionsFromLabels([label]).length === 0)) {
    return { ok: false };
  }
  const picked = (pendingSelection || []).filter((label) => label !== NO_ACTIONS_LABEL);
  const actions = onboardingActionsFromLabels([...picked, ...typed]);
  if (actions.length === 0) return { ok: false };
  return {
    ok: true,
    value: { selectedActions: actions },
    display: actions.map((action) => action.label).join(", "),
  };
}
